export function createGateUseCase(gateData, gateRepostitory) {
    const new_gate = new gateRepostitory.model_create(gateData);

    const is_valid = new_gate.isValid();

    if (is_valid != true) {
      throw new Error(is_valid);
    }

    return gateRepostitory.save(new_gate);
}